import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { backend } from "../../../path";
import DashboardSidebarMain from "../dashsidebar";

function DashboardVendorMain() {
  const [vendorList, setVendorList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Form State for new vendor registration
  const [newVendor, setNewVendor] = useState({
    vendor_name: "",
    email: "",
    phone: "",
    company_address: "",
    category: "Spices & Aromatics",
    vendor_rating: 5.0,
    vendor_review_count: 0,
    status: 1,
    revenue: "₹0/-",
    products_count: 0
  });

  const getMockVendors = () => [
    {
      user_id: 101,
      vendor_name: "Malabar Spice Cooperative",
      email: "contact@malabarspices.in",
      phone: "+91 98456 12345",
      company_address: "Wayanad Hills, Kerala, 670645",
      vendor_rating: 4.8,
      vendor_review_count: 142,
      status: 1, // Active
      category: "Spices & Aromatics",
      revenue: "₹4,82,500/-",
      products_count: 18,
    },
    {
      user_id: 102,
      vendor_name: "Kalarikkal Ayurvedic Pharmacy",
      email: "healing@kalarikkal.org",
      phone: "+91 73566 98765",
      company_address: "Kottakkal, Malappuram, Kerala, 676503",
      vendor_rating: 4.9,
      vendor_review_count: 98,
      status: 1, // Active
      category: "Ayurveda & Wellness",
      revenue: "₹3,15,400/-",
      products_count: 12,
    },
    {
      user_id: 103,
      vendor_name: "Balaramapuram Weavers Guild",
      email: "balaramapuram.weavers@gmail.com",
      phone: "+91 88911 23456",
      company_address: "Balaramapuram, Trivandrum, Kerala, 695501",
      vendor_rating: 4.7,
      vendor_review_count: 64,
      status: 1, // Active
      category: "Handlooms & Garments",
      revenue: "₹2,78,900/-",
      products_count: 24,
    },
    {
      user_id: 104,
      vendor_name: "Grandma's Chips & Snacks",
      email: "sales@grandmaschips.in",
      phone: "+91 94471 55667",
      company_address: "Calicut Bypass, Kozhikode, 673014",
      vendor_rating: 4.6,
      vendor_review_count: 215,
      status: 1, // Active
      category: "Savory & Crispy",
      revenue: "₹5,24,800/-",
      products_count: 15,
    },
    {
      user_id: 105,
      vendor_name: "Aranmula Metal Mirror Guild",
      email: "aranmulamirror@heritage.in",
      phone: "+91 98470 33445",
      company_address: "Aranmula, Pathanamthitta, Kerala, 689533",
      vendor_rating: 5.0,
      vendor_review_count: 36,
      status: 0, // Pending Approval
      category: "Kerala Heritage Decor",
      revenue: "₹0/-",
      products_count: 5,
    }
  ];

  const fetchVendor = () => {
    setLoading(true);
    fetch(backend + "getvendor", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) throw new Error("API error");
        return response.json();
      })
      .then((data) => {
        if (data && data.length > 0) {
          const merged = data.map((v, i) => ({
            user_id: v.user_id || i + 200,
            vendor_name: v.vendor_name,
            email: v.email || `${v.vendor_name.toLowerCase().replace(/\s+/g, "")}@keralaspecial.in`,
            phone: v.phone || "+91 98765 43210",
            company_address: v.company_address || "Trivandrum, Kerala, 695001",
            vendor_rating: v.vendor_rating || (4.5 + (i % 6) * 0.1),
            vendor_review_count: v.vendor_review_count || (10 + i * 5),
            status: v.status !== undefined ? v.status : 1,
            category: v.category || ["Spices & Aromatics", "Ayurveda & Wellness", "Handlooms & Garments", "Savory & Crispy"][i % 4],
            revenue: v.revenue || `₹${(20000 + i * 15000).toLocaleString()}/-`,
            products_count: v.products_count || (5 + i * 3)
          }));
          setVendorList(merged);
        } else {
          setVendorList(getMockVendors());
        }
      })
      .catch(() => {
        setVendorList(getMockVendors());
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchVendor();
  }, []);

  const handleStatusChange = (userId, newStatus) => {
    const updated = vendorList.map(v => {
      if (v.user_id === userId) {
        return { ...v, status: newStatus };
      }
      return v;
    });
    setVendorList(updated);

    const actionText = newStatus === 1 ? "Approved & Activated" : newStatus === 2 ? "Suspended" : "Moved to Pending";
    toast.success(`Vendor ${actionText} Successfully!`, {
      position: "top-right",
      autoClose: 3000
    });
  };

  const handleAddVendorSubmit = (e) => {
    e.preventDefault();
    if (!newVendor.vendor_name || !newVendor.email || !newVendor.phone) {
      toast.error("Please fill in all mandatory fields.");
      return;
    }

    const created = {
      ...newVendor,
      user_id: Date.now()
    };

    setVendorList([created, ...vendorList]);
    setIsModalOpen(false);
    toast.success("New Artisan Vendor Registered Successfully!", {
      position: "top-right",
      autoClose: 3000
    });

    // Reset Form
    setNewVendor({
      vendor_name: "",
      email: "",
      phone: "",
      company_address: "",
      category: "Spices & Aromatics",
      vendor_rating: 5.0,
      vendor_review_count: 0,
      status: 1,
      revenue: "₹0/-",
      products_count: 0
    });
  };

  const filteredVendors = vendorList.filter(v =>
    v.vendor_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    v.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
    v.company_address.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <ToastContainer />
      <DashboardContainer>
        <DashboardSidebarMain />
        <MainPanel>
          <HeaderRow>
            <div>
              <span className="subtitle">Artisan Management Panel</span>
              <h2 className="title">Artisans &amp; Vendors</h2>
            </div>
            <RegisterButton onClick={() => setIsModalOpen(true)}>
              <Icon icon="ic:round-add" size={20} />
              <span>Register New Vendor</span>
            </RegisterButton>
          </HeaderRow>

          {/* Stats Section */}
          <StatsGrid>
            <StatCard>
              <div className="icon-wrapper emerald">
                <Icon icon="mdi:storefront" />
              </div>
              <div className="stat-info">
                <span className="label">Total Artisans</span>
                <h3 className="value">{vendorList.length}</h3>
              </div>
            </StatCard>

            <StatCard>
              <div className="icon-wrapper gold">
                <Icon icon="mdi:checkbox-marked-circle" />
              </div>
              <div className="stat-info">
                <span className="label">Active Sellers</span>
                <h3 className="value">{vendorList.filter(v => v.status === 1).length}</h3>
              </div>
            </StatCard>

            <StatCard>
              <div className="icon-wrapper bark">
                <Icon icon="mdi:package-variant" />
              </div>
              <div className="stat-info">
                <span className="label font-medium">Total Products Listed</span>
                <h3 className="value">
                  {vendorList.reduce((acc, curr) => acc + (curr.products_count || 0), 0)}
                </h3>
              </div>
            </StatCard>

            <StatCard>
              <div className="icon-wrapper active-gold">
                <Icon icon="mdi:wallet-giftcard" />
              </div>
              <div className="stat-info">
                <span className="label">Combined Sales</span>
                <h3 className="value">₹16,01,600/-</h3>
              </div>
            </StatCard>
          </StatsGrid>

          {/* Search & Actions Bar */}
          <FilterBar>
            <SearchWrapper>
              <Icon icon="material-symbols:search" className="search-icon" />
              <SearchInput
                type="text"
                placeholder="Search by vendor name, category, or region..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </SearchWrapper>
          </FilterBar>

          {/* Table Container */}
          <TableContainer>
            <VendorTable>
              <thead>
                <tr>
                  <th>Vendor details</th>
                  <th>Core Category</th>
                  <th>Region / Location</th>
                  <th>Artisan Rating</th>
                  <th>Listed Products</th>
                  <th>Revenue Generated</th>
                  <th>Status</th>
                  <th style={{ textAlign: "right" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="text-center py-10">
                      <div className="spinner"></div>
                      <span className="ml-3 text-kerala-bark">Loading vendor data...</span>
                    </td>
                  </tr>
                ) : filteredVendors.length > 0 ? (
                  filteredVendors.map((v) => (
                    <tr key={v.user_id}>
                      <td>
                        <VendorNameBlock>
                          <span className="name">{v.vendor_name}</span>
                          <span className="meta">{v.email} | {v.phone}</span>
                        </VendorNameBlock>
                      </td>
                      <td>
                        <span className="category-tag">{v.category}</span>
                      </td>
                      <td>
                        <span className="address-text">{v.company_address}</span>
                      </td>
                      <td>
                        <RatingBlock>
                          <Icon icon="material-symbols:star" className="star" />
                          <span className="rating-value">{v.vendor_rating?.toFixed(1)}</span>
                          <span className="review-count">({v.vendor_review_count})</span>
                        </RatingBlock>
                      </td>
                      <td>
                        <span className="num-text">{v.products_count} Items</span>
                      </td>
                      <td>
                        <span className="revenue-text">{v.revenue}</span>
                      </td>
                      <td>
                        {v.status === 1 ? (
                          <StatusBadge className="active">Active</StatusBadge>
                        ) : v.status === 2 ? (
                          <StatusBadge className="suspended">Suspended</StatusBadge>
                        ) : (
                          <StatusBadge className="pending">Pending Approval</StatusBadge>
                        )}
                      </td>
                      <td>
                        <ActionButtonsWrapper>
                          {v.status !== 1 && (
                            <ActionButton
                              className="approve"
                              onClick={() => handleStatusChange(v.user_id, 1)}
                              title="Approve / Activate Vendor"
                            >
                              <Icon icon="mdi:check-circle" />
                            </ActionButton>
                          )}
                          {v.status === 1 && (
                            <ActionButton
                              className="suspend"
                              onClick={() => handleStatusChange(v.user_id, 2)}
                              title="Suspend Vendor"
                            >
                              <Icon icon="mdi:alert-circle" />
                            </ActionButton>
                          )}
                          <ActionButton
                            className="edit"
                            title="Edit Details"
                            onClick={() => {
                              toast.info("Artisan Edit Panel coming soon with remote database link.");
                            }}
                          >
                            <Icon icon="mdi:pencil" />
                          </ActionButton>
                        </ActionButtonsWrapper>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center py-12 text-kerala-bark/60 italic">
                      No vendors matching your search description.
                    </td>
                  </tr>
                )}
              </tbody>
            </VendorTable>
          </TableContainer>
        </MainPanel>
      </DashboardContainer>

      {/* Slideout Form Drawer Modal */}
      {isModalOpen && (
        <ModalOverlay onClick={() => setIsModalOpen(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <h3>Register New Vendor</h3>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>
                <Icon icon="material-symbols:close" />
              </button>
            </ModalHeader>

            <form onSubmit={handleAddVendorSubmit}>
              <FormGroup>
                <label>Artisan/Cooperative Name <span className="req">*</span></label>
                <input
                  type="text"
                  placeholder="e.g. Kottayam Organic Honey Co."
                  required
                  value={newVendor.vendor_name}
                  onChange={(e) => setNewVendor({ ...newVendor, vendor_name: e.target.value })}
                />
              </FormGroup>

              <FormGroup>
                <label>Primary Business Email <span className="req">*</span></label>
                <input
                  type="email"
                  placeholder="e.g. contact@kottayamhoney.in"
                  required
                  value={newVendor.email}
                  onChange={(e) => setNewVendor({ ...newVendor, email: e.target.value })}
                />
              </FormGroup>

              <FormGroup>
                <label>Contact Phone Number <span className="req">*</span></label>
                <input
                  type="text"
                  placeholder="e.g. +91 99887 76655"
                  required
                  value={newVendor.phone}
                  onChange={(e) => setNewVendor({ ...newVendor, phone: e.target.value })}
                />
              </FormGroup>

              <FormGroup>
                <label>Core Category</label>
                <select
                  value={newVendor.category}
                  onChange={(e) => setNewVendor({ ...newVendor, category: e.target.value })}
                >
                  <option value="Spices & Aromatics">Spices &amp; Aromatics</option>
                  <option value="Ayurveda & Wellness">Ayurveda &amp; Wellness</option>
                  <option value="Handlooms & Garments">Handlooms &amp; Garments</option>
                  <option value="Savory & Crispy">Savory &amp; Crispy</option>
                  <option value="Kerala Heritage Decor">Kerala Heritage Decor</option>
                </select>
              </FormGroup>

              <FormGroup>
                <label>Artisan Origin Address / Region</label>
                <textarea
                  rows={3}
                  placeholder="e.g. Ward 4, Kumarakom East, Kottayam, Kerala 686563"
                  value={newVendor.company_address}
                  onChange={(e) => setNewVendor({ ...newVendor, company_address: e.target.value })}
                />
              </FormGroup>

              <FormActions>
                <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  Submit Registration
                </button>
              </FormActions>
            </form>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
}

// Styled Components
const DashboardContainer = styled.div`
  display: flex;
  background: #FDFBF7;
  min-height: 100vh;
  font-family: "Jost", sans-serif;
  margin-top: 110px; /* Offset standard header */
`;

const MainPanel = styled.div`
  flex: 1;
  padding: 40px;
  background: #FDFBF7;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  padding-bottom: 20px;

  .subtitle {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #c5a880;
  }

  .title {
    font-family: "Playfair Display", serif;
    font-size: 32px;
    font-weight: 700;
    color: #123524;
    margin: 5px 0 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
`;

const RegisterButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #123524 0%, #0d261a 100%);
  color: #FDFBF7;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-family: "Jost", sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(18, 53, 36, 0.15);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(18, 53, 36, 0.25);
    background: linear-gradient(135deg, #D4AF37 0%, #C5A880 100%);
    color: #123524;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const StatCard = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 30px rgba(197, 168, 128, 0.1);
    border-color: #D4AF37;
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 12px;
    font-size: 24px;

    &.emerald {
      background: rgba(18, 53, 36, 0.08);
      color: #123524;
    }
    &.gold {
      background: rgba(212, 175, 55, 0.08);
      color: #D4AF37;
    }
    &.bark {
      background: rgba(45, 31, 24, 0.08);
      color: #2D1F18;
    }
    &.active-gold {
      background: rgba(197, 168, 128, 0.08);
      color: #C5A880;
    }
  }

  .stat-info {
    .label {
      display: block;
      font-size: 12px;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
    }

    .value {
      font-size: 24px;
      font-weight: 700;
      color: #2D1F18;
      margin: 0;
    }
  }
`;

const FilterBar = styled.div`
  margin-bottom: 24px;
`;

const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 450px;

  .search-icon {
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #c5a880;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px 12px 48px;
  font-family: "Jost", sans-serif;
  font-size: 14px;
  border: 1px solid rgba(197, 168, 128, 0.25);
  border-radius: 50px;
  background: #FFFFFF;
  color: #2D1F18;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #123524;
    box-shadow: 0 4px 15px rgba(18, 53, 36, 0.08);
  }
`;

const TableContainer = styled.div`
  border: 1px solid rgba(197, 168, 128, 0.15);
  border-radius: 16px;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0 4px 25px rgba(45, 31, 24, 0.02);

  @media (max-width: 1024px) {
    overflow-x: auto;
  }
`;

const VendorTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;

  thead {
    background: #F2ECE1;
    border-bottom: 1px solid rgba(197, 168, 128, 0.15);

    th {
      padding: 18px 20px;
      font-weight: 600;
      color: #123524;
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 0.05em;
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid rgba(197, 168, 128, 0.1);
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(242, 236, 225, 0.2);
      }

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      padding: 18px 20px;
      vertical-align: middle;
      color: #2D1F18;
    }
  }

  .spinner {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 3px solid rgba(18, 53, 36, 0.1);
    border-radius: 50%;
    border-top-color: #123524;
    animation: spin 1s ease-in-out infinite;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

const VendorNameBlock = styled.div`
  display: flex;
  flex-direction: column;

  .name {
    font-weight: 600;
    font-size: 15px;
    color: #123524;
  }

  .meta {
    font-size: 11px;
    color: #777;
    margin-top: 2px;
  }
`;

const CategoryTag = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  background: rgba(197, 168, 128, 0.1);
  color: #8c7623;
`;

const RatingBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  .star {
    color: #D4AF37;
    font-size: 18px;
  }

  .rating-value {
    font-weight: 600;
    color: #2D1F18;
  }

  .review-count {
    font-size: 11px;
    color: #777;
  }
`;

const StatusBadge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  &.active {
    background: rgba(18, 53, 36, 0.08);
    color: #123524;
    border: 1px solid rgba(18, 53, 36, 0.15);
  }

  &.suspended {
    background: rgba(220, 53, 69, 0.08);
    color: #dc3545;
    border: 1px solid rgba(220, 53, 69, 0.15);
  }

  &.pending {
    background: rgba(212, 175, 55, 0.08);
    color: #8c7623;
    border: 1px solid rgba(212, 175, 55, 0.15);
  }
`;

const ActionButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #eee;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;

  &.approve {
    color: #123524;
    border-color: rgba(18, 53, 36, 0.15);
    background: rgba(18, 53, 36, 0.03);

    &:hover {
      background: #123524;
      color: #FFF;
      transform: scale(1.05);
    }
  }

  &.suspend {
    color: #dc3545;
    border-color: rgba(220, 53, 69, 0.15);
    background: rgba(220, 53, 69, 0.03);

    &:hover {
      background: #dc3545;
      color: #FFF;
      transform: scale(1.05);
    }
  }

  &.edit {
    color: #c5a880;
    border-color: rgba(197, 168, 128, 0.2);

    &:hover {
      background: #c5a880;
      color: #FFF;
      transform: scale(1.05);
    }
  }
`;

// Modal Styles
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(45, 31, 24, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 11000;
  animation: fadeIn 0.3s ease-out;
`;

const ModalContent = styled.div`
  background: #FDFBF7;
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  padding: 30px;
  border: 1px solid rgba(197, 168, 128, 0.2);
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  padding-bottom: 15px;

  h3 {
    font-family: "Playfair Display", serif;
    font-size: 22px;
    font-weight: 700;
    color: #123524;
    margin: 0;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #777;
    transition: color 0.2s ease;

    &:hover {
      color: #dc3545;
    }
  }
`;

const FormGroup = styled.div`
  margin-bottom: 18px;

  label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #2D1F18;
    margin-bottom: 6px;

    .req {
      color: #dc3545;
    }
  }

  input, select, textarea {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid rgba(197, 168, 128, 0.3);
    border-radius: 8px;
    background: #FFF;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    color: #2D1F18;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: #123524;
      box-shadow: 0 4px 12px rgba(18, 53, 36, 0.05);
    }
  }

  textarea {
    resize: none;
  }
`;

const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 25px;
  border-top: 1px solid rgba(197, 168, 128, 0.15);
  padding-top: 20px;

  button {
    padding: 12px 24px;
    border-radius: 50px;
    font-family: "Jost", sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .cancel-btn {
    background: transparent;
    color: #777;
    border: 1px solid #ddd;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
      border-color: #999;
    }
  }

  .submit-btn {
    background: linear-gradient(135deg, #123524 0%, #0d261a 100%);
    color: #FDFBF7;
    border: none;

    &:hover {
      background: linear-gradient(135deg, #D4AF37 0%, #C5A880 100%);
      color: #123524;
    }
  }
`;

export default DashboardVendorMain;
